import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SiteNav, MinimalFooter, useReveal } from './shared';
import Seo from './Seo';

export default function NotFound() {
  useReveal();
  const navigate = useNavigate();
  const goHome = () => navigate('/');

  return (
    <div className="page-enter" data-screen-label="404 Nicht gefunden">
      <Seo path="/404" title="Seite nicht gefunden — hamba" description="Diese Seite existiert nicht." noindex />
      <SiteNav />

      <section style={{ padding: '160px 0', minHeight: '60vh' }}>
        <div className="shell" style={{ textAlign: 'center' }}>
          <div className="reveal" style={{ maxWidth: 640, margin: '0 auto' }}>
            <div
              style={{
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                fontSize: 12,
                letterSpacing: '0.18em',
                color: 'var(--charcoal-faint)',
                textTransform: 'uppercase',
                marginBottom: 28,
              }}
            >
              404 · Nicht gefunden
            </div>

            <h1
              className="h-display"
              style={{
                fontSize: 'clamp(48px, 6vw, 84px)',
                lineHeight: 1.05,
                letterSpacing: '-0.01em',
                marginBottom: 24,
              }}
            >
              Diese Seite existiert nicht.
            </h1>

            <p
              className="lede"
              style={{
                fontSize: 19,
                fontStyle: 'italic',
                fontFamily: 'var(--serif)',
                color: 'var(--charcoal-muted)',
                maxWidth: '60ch',
                margin: '0 auto 40px',
                lineHeight: 1.55,
              }}
            >
              Vielleicht haben Sie sich vertippt, oder die Seite wurde verschoben.
            </p>

            <button
              type="button"
              onClick={goHome}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 12,
                padding: '16px 32px',
                background: 'var(--bordeaux)',
                color: 'var(--cream)',
                fontFamily: 'var(--grotesk)',
                fontSize: 14,
                letterSpacing: '0.08em',
                fontWeight: 500,
                border: '1px solid var(--bordeaux)',
                borderRadius: 1,
                cursor: 'pointer',
                transition: 'background 200ms ease',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--bordeaux-soft)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--bordeaux)'; }}
            >
              <span aria-hidden="true">←</span> Zurück zur Startseite
            </button>
          </div>
        </div>
      </section>

      <MinimalFooter />
    </div>
  );
}
